import React from "react";
import PaymentPageHeaderService from "./PaymentPageHeaderService";
import { NavLink } from "react-router-dom";
import { API_BASEURLICON } from "../../Config";

const PaymentPageHeader = () => {
  const { toggleDropdown, showDropdown, handleLogout } =
    PaymentPageHeaderService();

  const name = sessionStorage.getItem("name");
  const emailID = sessionStorage.getItem("emailID");
  const mobileNo = sessionStorage.getItem("mobileNo");
  const userId = sessionStorage.getItem("userID");
  const isLoggedIn =
    sessionStorage.getItem("session") && sessionStorage.getItem("sessionID");

  const defaultAvatar =
    "https://pwa-cdn.freecharge.in/pwa-static/pwa/images/header/login-icon.png";
  const imageUrl = API_BASEURLICON;

  return (
    <>
      <header className="main-header ">
        <div className="main-wrapper header-content">
          <div className="header-logo">
            <img
              src={`${imageUrl}Image/Website/1/B2C-whitelogo.png`}
              alt="Pocketvila Logo"
              className="fc-logo"
            />
          </div>
          <div className="header-options">
            <div
              className="header-login"
              style={{ position: "relative", cursor: "pointer" }}
            >
              <img
                src={defaultAvatar}
                alt="profile avatar"
                className="profile-avatar"
                onClick={toggleDropdown}
              />

              {showDropdown && (
                <div className="profile-dropdown">
                  <div className="content-box">
                    <div className="user-details">
                      <img
                        src="https://pwa-cdn.freecharge.in/pwa-static/pwa/images/header/login-icon.png"
                        alt="profile avatar"
                        className="profile-avatar"
                      />
                      <div className="content-section">
                        <div className="user-name">
                          <h3 title="Mohd anzar">{name}</h3>
                        </div>
                        <p
                          className="phone-field account-field-labels"
                          title="Phone : 9044004486"
                        >
                          <span className="account-label-texts">Phone</span>:
                          {mobileNo}
                        </p>
                        <p
                          className="email-field account-field-labels"
                          title="Email :support@ayyun.co.in "
                        >
                          <span className="account-label-texts">Email</span>:
                          {emailID}
                        </p>
                        <div
                          className="upi-field upi-status account-field-labels"
                          title="UPI ID : 01169272993@freecharge"
                        >
                          <span className="account-label-texts">UserID</span>
                          <div className="entity-wrapper">
                            <span className="upi-id">:{userId}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {isLoggedIn ? (
                <span
                  className="login-btn"
                  onClick={handleLogout}
                  style={{ cursor: "pointer" }}
                >
                  Logout
                </span>
              ) : (
                <NavLink to="/login">
                  <span className="login-btn">Login</span>
                </NavLink>
              )}
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default PaymentPageHeader;
